import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/styles/index.css";
import App from "./App";
import { Provider } from "react-redux";
import { Toaster } from "sonner";
import store from "./context/store/store";
import "bootstrap-icons/font/bootstrap-icons.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
    <Toaster
      expand
      visibleToasts={3}
      position="top-center"
      className="my-toast"
      toastOptions={{
        style: { background: "white" },
        className: "my-toast",
      }}
      richColors
      pauseWhenPageIsHidden
      duration={4500}
      offset="1rem"
    />
  </Provider>
);
